module.exports = __webpack_public_path__ + "static/media/insuranceIcon.0c3a0629.svg";